/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import React, { useEffect, useState } from 'react'
import GridContainer from '../common/grid/GridContainer'
import { DEBI_CREATE_FORM, DEBI_DETAILS, STATUS } from '../../utils/constants/GlobalFormConstants'
import GridItem from '../common/grid/GridItem'
import Typo from '../common/typo/Typo'
import { FORM_FONT_STYLE, DEBI_ROLE,LABEL_MAP, VALIDATION_MSG_STYLE, COLOR_RED } from '../../utils/constants/GlobalConstants'
import TextInput from '../common/textInput/TextInput'
import { getUserRole, getUserName } from '../../services/userService'
import { DebiValidations } from '../../utils/helpers/Validation'

const DebiDetailsInfo = (props) => {
    const [debiData, setDebiData] = useState();
    const [ownContract, setOwnContract] = useState(false);
    const [validationMsgs, setValidationMsgs] = React.useState([]);

    const getFieldLabel = (key) => {
        const labelMap = {
            businessName: LABEL_MAP.BNAME,
            telephone: LABEL_MAP.TEL,
            installerStreetAddress: LABEL_MAP.STREET_ADDRESS,
            installerEmail: LABEL_MAP.INSTALLER_EMAIL,
            installerCity: LABEL_MAP.CITY,
            installerState: LABEL_MAP.STATE,
            zipCode: LABEL_MAP.ZIPCODE,
        }
        return labelMap[key] || key
    }
    useEffect(() =>{
        props?.details?.debis && setDebiData(props?.details?.debis[0]);
        if (props?.details?.debis ) {
            const role = getUserRole();
            const userName = getUserName();
            setOwnContract((role === DEBI_ROLE.SALES_REP || role === DEBI_ROLE.PARTS_ADMIN ) &&
             (props?.details?.debis[0]?.statusReason !== STATUS.OPEN) && 
             (props?.details?.debis[0]?.statusReason !== STATUS.CLOSED ) && 
             (props?.details?.docusignDetails && props?.details?.docusignDetails?.length === 0 ) &&
              (userName === props?.details?.debis[0]?.createdBy))
        } else {
            setOwnContract(false);
        }
    }, [props])
   useEffect(() => {
        if (debiData) {
            props.changeUpdatedValue(debiData);
        }
    }, [debiData])

    const handleInputChange = (e, key) => {
        setDebiData((prevState) => (
            {
                ...prevState,
                [key]: e.target.value
            }
        ));
        let tempMsg = DebiValidations({ [key]: e.target.value });
        setValidationMsgs((prev) => prev.filter((msg) => !msg.includes(getFieldLabel(key))).concat(tempMsg))
    }
    useEffect(()=>{
        
 props.onValidationChange(validationMsgs);
 
    },[validationMsgs])
  
    const checkMsg = (label) => {
        return validationMsgs.map((item) => {
          if (item.includes(label))
            return (
              <Typo
                variant="body2"
                text={item}
                color="secondary"
                sx={{...COLOR_RED }}
              />
            );
        });
      };
    const getDetails = (data) => {
        let details
        if (debiData) {
            details = debiData
        } else if (props.details?.debiDTO) {
            details = props.details.debiDTO
        }
       if(props?.editClicked){
        details.statusReason="Incomplete";
       }
        for (let key in details) {
            if (data.key === key) {
                return details[key];
            }
        }
    }

    const isEditableKeys = [
        "businessName",
        "telephone",
        "installerStreetAddress",
        "installerEmail",
        "installerCity",
        "installerState",
        "zipCode"
    ]
    return (
        <div className='form-layout'>
            <GridContainer spacing={2}>
                {[...DEBI_DETAILS, ...DEBI_CREATE_FORM].map((data, index) => {
                    const isEditableField = isEditableKeys.includes(data.key);
                    const isDebiDetailsField = ownContract ? DEBI_DETAILS.some((detail) => detail?.key === data?.key) : [...DEBI_DETAILS, ...DEBI_CREATE_FORM].some((detail) => detail.key === data.key);
                    return (
                        <GridItem xs={12} sm={4} lg={4} md={4} xl={4} key={index}>
                            <Typo variant='body2' text={isEditableField && ownContract ? '' : data.label} color="secondary" sx={FORM_FONT_STYLE} />
                            {isDebiDetailsField ? 
                            (<Typo variant='body2' text={getDetails(data) ? getDetails(data) : '--'} color="secondary" />)
                                : isEditableField ? (
                                    <>
                                        <TextInput testid ="debidetails" label={data.label} required={true} onChange={(e) => handleInputChange(e, data.key)} value={getDetails(data) ? getDetails(data) : ''} />
                                        <div style={VALIDATION_MSG_STYLE}>{ validationMsgs &&
                         validationMsgs.length > 0 && checkMsg(data.label)}</div></>
                                    )
                            : (<TextInput label={data.label} required={true} InputProps={{ readOnly: true }} />)}

                        </GridItem>
                    )
                })}
            </GridContainer>
        </div>
    )
}

export default DebiDetailsInfo